import React from "react";
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthProvider/AuthProvider";

const Privateroute = ({ children }) => {
  const user = useContext(AuthContext);

  if (user && user.uid) {
    return children;
   
  }
  return <Navigate to="/login"></Navigate>;
};

export default Privateroute;
